// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Supprime le margin-bottom du SuiviHeader pour coller le bandeau simulation */
.demo-header-no-gap .suivi-commande-title {
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/pages/Publications/components/DemoDetailCandidature/DemoDetailCandidature.css"],"names":[],"mappings":"AAAA,+EAA+E;AAC/E;EACE,gBAAgB;AAClB","sourcesContent":["/* Supprime le margin-bottom du SuiviHeader pour coller le bandeau simulation */\n.demo-header-no-gap .suivi-commande-title {\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
